import { floor, round } from 'lodash';

import { MINUTES_PER_HOUR } from '../../constants';
import { parseNumber } from '../FormatHelpers/FormatHelpers';

/*
    Преобразует целочисленное количество минут в формат строки 00:00
*/
export const formatTimeNumberToString = (value: number): string => {
    const { hour, minute } = formatMinuteTimeToStructuredTime(value);
    const formatHours = hour < 10 ? '0' + hour : String(hour);
    const formatMinutes = minute < 10 ? '0' + minute : String(minute);

    return formatHours + ':' + formatMinutes;
};

/*
    Преобразует формат строки 00:00 в целочисленное количество минут
*/
export const formatTimeStringToNumber = (value: string): number | undefined => {
    const timeList = value.split(':');

    // формату времени удовлетворяет только 00:00
    if (timeList.length !== 2 || value.length !== 5) {
        return undefined;
    }

    const hour = parseNumber(timeList[0]);
    const minute = parseNumber(timeList[1]);

    return formatStructuredTimeToMinuteTime({
        hour,
        minute
    });
};

/*
    Дополняет строки нулями до формата 00:00
    например
    12 -> 12:00
    1 -> 10:00
    14:2 -> 14:20
*/
export const getTimeStringWithFillingZeros = (value: string): string => {
    if (value === '') {
        return '';
    }

    let timeList = value.split(':');

    if (value.length < 5 || timeList.length < 2) {
        for (let i = 0; i < 2 - timeList.length; i++) {
            timeList.push('');
        }
        timeList = timeList.map(addZeroForNotFullTimerNumber);
    }

    return timeList.join(':');
};

export const addZeroForNotFullTimerNumber = (value: string): string => {
    if (value.length === 0) {
        return '00';
    }

    if (value.length === 1) {
        return value + '0';
    }

    return value;
};

export const formatStructuredTimeToMinuteTime = ({
    hour,
    minute
}: {
    hour: number;
    minute: number;
}): number => {
    return hour * MINUTES_PER_HOUR + minute;
};

export const formatMinuteTimeToStructuredTime = (
    value: number
): {
    hour: number;
    minute: number;
} => {
    return {
        hour: floor(value / MINUTES_PER_HOUR),
        minute: value % MINUTES_PER_HOUR
    };
};

export const roundMinuteTimeByCurrentValue = (
    minuteTime: number,
    roundValue: number
): number => {
    return round(minuteTime / roundValue) * roundValue;
};

export const getRoundedHoursByMinutes = (minutes: number): number => {
    return Math.round(minutes / MINUTES_PER_HOUR);
};
